import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i2 from '@upr-web-primer/locale';
import { LocaleModule } from '@upr-web-primer/locale';
import * as i1 from '@upr-web-primer/tcm-service';
import { get, merge } from 'lodash-es';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, first } from 'rxjs/operators';
class PageLabelsModule {
  static {
    this.ɵfac = function PageLabelsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageLabelsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PageLabelsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideHttpClient(withInterceptorsFromDi())],
      imports: [LocaleModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLabelsModule, [{
    type: NgModule,
    args: [{
      imports: [LocaleModule],
      providers: [provideHttpClient(withInterceptorsFromDi())]
    }]
  }], null, null);
})();
const PageLabelsUrls = {
  GET_PAGE_LABELS: '/%language%/%country%/api/pageinfo.html'
};
class PageLabelsResolver {
  constructor(tridion, locale, iceDataUrl) {
    this.tridion = tridion;
    this.locale = locale;
    this.iceDataUrl = iceDataUrl;
    this.$pageLabels = new BehaviorSubject(undefined);
    this.subscriptions = new Subscription();
    const publication = this.tridion.tridionEnvConfig.publication;
    let url = PageLabelsUrls.GET_PAGE_LABELS;
    if (this.tridion.tridionEnvConfig.dynamic_path_enabled) {
      this.subscriptions.add(this.tridion.siteConfig$.subscribe(config => {
        if (config?.tridion_pub) {
          url = config.tridion_pub + url;
        } else {
          url = publication + url;
        }
        this.pageInfoUrl = url;
      }));
    } else {
      this.pageInfoUrl = publication + url;
    }
  }
  get() {
    return this.$pageLabels.pipe(filter(Boolean), first()).toPromise();
  }
  resolve() {
    return this.get().then(pageLabels => pageLabels);
  }
  init() {
    this.getData();
  }
  getData() {
    const locale = this.locale.getFromStorage();
    const dataUrl = (this.iceDataUrl || '').replace('%language%', locale.language).replace('%country%', locale.country);
    const pageInfoUrl = (this.pageInfoUrl || '').replace('%language%', locale.language).replace('%country%', locale.country);
    const calls = [];
    if (pageInfoUrl) {
      calls.push(this.tridion.request(pageInfoUrl));
    }
    if (dataUrl) {
      calls.push(this.tridion.request(dataUrl));
    }
    return Promise.all(calls).then(data => {
      const firstObj = get(data, '0.ResourceList') ? merge(get(data, '0.ResourceList', {}), get(data, '0.AttractionLocationImages', {})) : get(data, '0', {});
      this.$pageLabels.next(merge(get(data, '1', {}), firstObj));
    }).catch(error => {
      console.error(error);
      this.$pageLabels.next({});
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static {
    this.ɵfac = function PageLabelsResolver_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageLabelsResolver)(i0.ɵɵinject(i1.TcmService), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject('IceDataUrl'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PageLabelsResolver,
      factory: PageLabelsResolver.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLabelsResolver, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.TcmService
  }, {
    type: i2.LocaleService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['IceDataUrl']
    }]
  }], null);
})();

/*
 * Public API Surface of page-labels
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PageLabelsModule, PageLabelsResolver };
